/*
 * @Author: Merlin
 * @Date: 2024-01-15 19:32:25
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-16 10:30:34
 * @Description: 
 */

// ▼用于游戏 keno
export const oKenoGame = {
    'ClearTable': {
        en: 'Clear Table', 
        cn: '清除已选',
    },
    'AutoPick': {
        en: 'Auto Pick', 
        cn: '自动抽选',
    },
    'PickFrom1': {
        en: 'Click to select a number from 1 to 10, the more you guess, the higher the multiplier!', 
        cn: '点击选择1到10个数字，押中越多，倍率越高！',
    },
    'RiskLevel': {
        en: 'Risk Level', 
        cn: '难度',
    },
    'ruleDesc01': {
        en: 'Select between 1 and 10 numbers and place your bet, the more lucky numbers generated that match the selected numbers, the higher the payout.',
        cn: '选择1到10个数字并下注，生成的幸运数字与所选数字匹配越多，赔率越高。',
    },
    'ruleDesc02': {
        en: '', // Mini 版中被废弃  
        cn: '',
    },
};




